export function returnValueHelper(state: boolean, value1: any, value2: any ) {
    return state ? value1 : value2;
}